import {createReducer, on} from "@ngrx/store";
import {initialCompanyState} from "../states/companyState.state";
import {setCurrentCompany} from "../actions/company.actions";

export const companyReducers = createReducer(
    initialCompanyState,
    on(setCurrentCompany, (state, { company }) => (
        {
            ...state,
            currentCompany: company
        }
    )),
);